import MediaReleases from "./MediaReleases";

export default MediaReleases;
